import './inputLinkPage.scss';

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';

import Form from 'react-bootstrap/Form';
import { Button } from 'react-bootstrap';
import { MDBSpinner } from 'mdb-react-ui-kit';

import ErrorPopup from '../../component/ErrorPopup/ErrorPopup';
import RunningBar from '../../component/RunningBar/RunningBar';


const InputLinkPage = ({onSubmit, errorMsg}) => {

    const { t } = useTranslation();
    const inputRef = useRef();
    const loading = useSelector(state => state.loading);    

    useEffect(() => {
        inputRef.current.focus();
        document.addEventListener('keydown', handleKeyDowm);
        return () => document.removeEventListener('keydown', handleKeyDowm);
    })

    const handleKeyDowm = (event) => {
        if (event.key === 'Enter' && !loading) {
            onSendLink();
        }
    }

    const onSendLink = async () => {
        if (inputRef.current.value) {
            await onSubmit(inputRef.current.value);
        }
    }

    const CustomSpinner = () => {
        return (
            <MDBSpinner role='status'
            className='input__page--spinner'>
            <span className='visually-hidden'>Loading...</span>
            </MDBSpinner>
        )
    }

    return (
        <div className="input-link--wrapper">
            <div className="input-link--container">

                
                <div className="input__page--text">
                    <p className='input__page--title'>
                    {t("input-page-title")}
                    </p>
                    {loading ? 
                        <p className='input__page--subtitle'>
                        {t("loading-data")}...
                        </p>
                    :
                        <p className='input__page--subtitle'>
                        {t("input-page-subtitle")}
                        </p>
                    }
                </div>
                {loading ? <RunningBar/> : null}


                <div className="form__container">
                    <div style={{width: '100%'}} className='input-container'>
                    <Form.Control 
                    ref={inputRef}
                    className='input-link--form'
                    size="lg" 
                    type="text" 
                    placeholder={t("input-placeholder")} />
                    </div>
                    <Button 
                    disabled={loading}
                    className='input__page--button'
                    onClick={() => onSendLink()}
                    variant="primary">
                        
                        {!loading ? <>{t("check-seo-input-page")}</> : null}
                        {loading ? <CustomSpinner/> : null}
                        
                    </Button>
                    {errorMsg ? <ErrorPopup errorMsg={errorMsg}/> : null}
                </div>
                {errorMsg ? <p className='error__input--text' style={{textAlign: 'left'}}>{errorMsg}</p> : null}
            </div>  
        </div>
    );
}
 
export default InputLinkPage;